/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_No_Results_DescriptionInputs */



/**
* | output |
* | --- |
* | "Try adjusting your search or category filter" |
*
* @param {Templates_No_Results_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const templates_no_results_description = /** @type {((inputs?: Templates_No_Results_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_No_Results_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Versuchen Sie, Ihre Suche oder Kategoriefilter anzupassen")
	return /** @type {LocalizedString} */ ("Try adjusting your search or category filter")
});